import React from "react";
import { hydrate } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from './app'
import "@arco-design/web-react/dist/css/arco.css";

hydrate(
  <BrowserRouter>
    <App/>
  </BrowserRouter>, 
  document.getElementById('root')
)
